/*  eslint no-shadow: ["error", { "allow": ["state"] }] */
/*  eslint no-param-reassign: ["error", { "props": false }] */
import Vue from "vue";
import Vuex from "vuex";
import { TicketService } from "@/services/ticket.service";
import { HelperService } from "@/services/helper.service";

Vue.use(Vuex);

const state = {
  tickets: [],
  selected: {},
  loading: false,
  totalCount: 0
};

const getters = {
  tickets: state => state.tickets,
  selectedTicket: state => state.selected,
  onLoading: state => state.loading,
  total: state => state.totalCount
};

const mutations = {
  setSelected(state, sel) {
    state.selected = sel;
  },
  setList(state, sel) {
    state.tickets = sel;
  },
  setTotal(state, sel) {
    state.totalCount = Number(sel);
  },
  setLoading(state, sel) {
    state.loading = sel;
  }
};

const actions = {
  async ajaxTicketSetSelected({ commit }, payload) {
    await HelperService.genericSetSelected(
      commit,
      TicketService.fetchOne,
      payload.id
    );
  },

  async ajaxTicketFetchAll({ commit }, payload) {
    let searchFilterPagination = HelperService.localToJSONAPIPagination(
      payload
    );
    searchFilterPagination.include = "tenant,customer,agreement,user,users";
    searchFilterPagination.sort = HelperService.fixIncludedResourceSorting(
      searchFilterPagination
    );

    await HelperService.genericFetchAll(
      commit,
      TicketService.fetchAll,
      searchFilterPagination,
      payload.headers_query,
      null
    );
  },

  async ajaxTicketCreateOrUpdate({ commit }, payload) {
    HelperService.unformatTicket(payload);
    return HelperService.genericCreateOrUpdate(
      commit,
      TicketService.createOrUpdate,
      payload
    );
  },

  async ajaxTicketDelete({ commit }, payload) {
    return HelperService.genericDelete(
      commit,
      TicketService.delete,
      payload.id
    );
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
